
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'BorgDyspneaScore',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Card/BorgDyspneaScore.vue